/**
* @file 运营中心-旅游包车订单
* */
<template>
  <div id="marketingActivity">

    <custom-table :has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"
      labelWidth="135" style="height: 100%" addText="新增活动" @addFn="addActivity">
      <template slot="table-operation">
        <el-table-column label="操作" width="120" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" @click="actionFn({ type: 'view', row: row })">查看</el-button>
            <el-button v-if="row.status < 3" type="text" @click="actionFn({ type: 'cancel', row: row })">作废
            </el-button>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="['created', 'startDate', 'endDate'].includes(item.prop)">
          {{ row[item.prop] | filterTime('YYYY-MM-DD') }}
        </template>
        <template v-else-if="item.prop == 'type'">
          {{ row[item.prop] | filterConst("ACTIVITYTYPE") }}
        </template>
        <template v-else-if="item.prop == 'activityLink'">
          <el-link type="primary" @click="$utils.copyText(`pages/activity/activity?activityId=${row.id}`)">pages/activity/activity?activityId={{ row.id }}</el-link>
        </template>
        <template v-else-if="item.prop == 'remainingNum'">
            <el-progress :percentage="row.progress" style="display: inline-block;width: 120px;" />
            <span>{{ row[item.prop] }}张</span>
        </template>
        <template v-else-if="item.prop == 'status'">
          <el-tag :type="row[item.prop] | filterConst('ACTIVITYSTATUS', 'tag')">{{ row[item.prop] | filterConst("ACTIVITYSTATUS") }}</el-tag>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <!-- 添加活动抽屉 -->
    <activity-add :visible.sync="activityDrawerVisible" @success="handleAddSuccess" />

    <!-- 活动详情抽屉 -->
    <el-drawer :visible.sync="activityDetailVisible" title="" size="900px">
      <activity-detail v-if="activityDetailVisible" :activityId="activityId" />
    </el-drawer>
  </div>
</template>

<script>
import ActivityAdd from './add.vue'
import ActivityDetail from './detail.vue'

export default {
  name: "marketingActivity",
  components: {
    ActivityAdd,
    ActivityDetail
  },
  data() {
    return {
      activityDrawerVisible: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/activity",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          {
            type: "select",
            field: "status",
            name: "活动状态",
            value: "",
            option: this.$const.ACTIVITYSTATUS,
          },
          { type: "input", field: "code", name: "活动ID", value: null },
          { type: "input", field: "name", name: "活动名称", value: "" },
          //   开始时间范围
          {
            type: "datetime",
            field: "startDate",
            dateProp: { start: "startDateBegin", end: "startDateEnd" },
            name: "开始时间",
            value: []
          },
          {
            type: "datetime",
            field: "endDate",
            dateProp: { start: "endDateBegin", end: "endDateEnd" },
            name: "结束时间",
            value: []
          },
        ],
      },
      // 表头
      columns: [
        { prop: "code", label: "活动ID", width: 100 },
        { prop: "name", label: "活动标题", minWidth: 120 },
        { prop: "type", label: "活动类型", width: 100 },
        { prop: "activityLink", label: "活动链接", width: 260 },
        { prop: "remainingNum", label: "优惠券剩余", width: 220 },
        { prop: "startDate", label: "开始时间", width: 100 },
        { prop: "endDate", label: "结束时间", width: 100 },
        { prop: "status", label: "活动状态", width: 100 },
      ],
      activityDetailVisible: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    actionFn({ type, row }) {
      if (type == 'view') {
        this.activityDetailVisible = true
        this.activityId = row.id
      }else if (type == 'cancel') {
        this.$confirm('确认作废当前活动？已发放奖励保留，未发放部分将失效', '活动作废', {
          confirmButtonText: '确认',
          cancelButtonText: '取消'
        }).then(async() => {
          const {code, data} = await this.$axios.put(`/api/v1/manage/activity/invalid`, {
            id: row.id
          })
          if(code == 1) {
            this.$message.success('作废成功')
              this.$refs.customTable.listFn()
          }
        })
      }
    },
    /**
     * 打开新增活动抽屉
     */
    addActivity() {
      this.activityDrawerVisible = true
    },

    /**
     * 新增活动成功回调
     */
    handleAddSuccess() {
      this.$refs.customTable.listFn()
    },
  },
  created() { },
};
</script>

<style scoped lang="less"></style>
